var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgMilestoneTimesheetSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.695 7.263 8.736 1.305a1.039 1.039 0 0 0-1.473 0L1.305 7.263C1.1 7.467 1 7.733 1 8s.101.534.304.736l5.959 5.959a1.04 1.04 0 0 0 1.473 0l5.959-5.958c.204-.204.305-.47.305-.737s-.101-.534-.305-.737ZM8 14.018 1.982 8 8 1.982 14.018 8 8 14.018Z",
    fill: "#525252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgMilestoneTimesheetSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/milestone-timesheet-settings.84abc03c758c15601fb23fe6446e254d.svg";